export default __webpack_public_path__ + "static/media/failed.71fd05e5.svg";